import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import { PageLoader } from 'src/components/PageLoader';

// PTMQRVA-506: dispara loginWithRedirect en mount para no mostrar el botón
// "Entrar". Con sesión activa en portal-modo-develop (SSO desde MODO Central
// u otro portal del mismo tenant) Auth0 vuelve sin mostrar UI.
const LoginPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const triggered = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || triggered.current) return;
    triggered.current = true;
    loginWithRedirect({ appState: { returnTo: '/transactions' } });
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return <PageLoader />;
};

export default LoginPage;
